import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token') !== null; // Adjust this based on your authentication method
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/adminLogin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
